module.exports = __webpack_public_path__ + "static/media/minus-square.708c6166.svg";